import * as tslib_1 from "tslib";
import { OnInit, ViewContainerRef } from '@angular/core';
import { util } from '../../../classes/util';
import { ESRI } from '../../../esri-loader-util';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var maxTextLayerNameLength = 75;
var initilizeDebounceTime = 50;
var Draw;
var Graphic;
var DrawTextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DrawTextComponent, _super);
    function DrawTextComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.defaultSymbolProperties = {
            type: 'text',
            color: 'white',
            horizontalAlignment: 'left',
            verticalAlignment: 'baseline',
            font: {
                size: '12px',
                family: 'Arial',
                weight: 'bold'
            }
        };
        _this.horizontalAlignmentOptions = ['left', 'right', 'center', 'justify'];
        _this.verticalAlignmentOptions = ['baseline', 'top', 'middle', 'bottom'];
        _this.fontSizeOptions = ['2', '4', '6', '8', '10', '12', '14', '16', '18', '20', '22', '24', '30', '32', '36', '40', '50', '64', '72'];
        _this.fontFamilyOptions = [
            { name: 'Arial', bold: true, italic: true },
            { name: 'Avenir Next LT Pro', bold: true, italic: true },
            { name: 'Black Ops One' },
            { name: 'Josefin Sans', italic: true },
            { name: 'Josefin Slab', bold: true, italic: true },
            { name: 'Merriweather', bold: true, italic: true },
            { name: 'Montserrat', bold: true, italic: true },
            { name: 'Noto Sans', bold: true, italic: true },
            { name: 'Old Standard TT', bold: true, italic: true },
            { name: 'Orbitron', bold: true },
            { name: 'Oregano', italic: true },
            { name: 'Oswald', bold: true },
            { name: 'Ubuntu', bold: true, italic: true },
            { name: 'Ubuntu Mono', bold: true, italic: true }
        ];
        _this.boldDisabled = false;
        _this.italicDisabled = false;
        _this.initializing = false;
        _this.listners = [];
        return _this;
    }
    Object.defineProperty(DrawTextComponent.prototype, "enabled", {
        set: function (enabled) {
            this._enabled = enabled;
            if (this._enabled) {
                this.setupHandleHiddenLayer();
                this.createPointDrawAction();
            }
            else {
                this.teardownHandleHiddenLayer();
                this.draw.reset();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawTextComponent.prototype, "fontFamilies", {
        get: function () {
            return this.fontFamilyOptions.map(function (fontOption) { return fontOption.name; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawTextComponent.prototype, "colorPickerRef", {
        set: function (el) { this.colorPicker = el; },
        enumerable: true,
        configurable: true
    });
    DrawTextComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, err_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 4, 5]);
                        this.createLayerForEachGraphic = true;
                        this.symbolProperties = this.defaultSymbolProperties;
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _b.mapView = _c.sent();
                        return [4 /*yield*/, Promise.all([ESRI.Draw, ESRI.Graphic])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), Draw = _a[0], Graphic = _a[1];
                        this.draw = new Draw({ view: this.mapView });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _c.sent();
                        this.readyProblem(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DrawTextComponent.prototype.createPointDrawAction = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var action;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                action = this.draw.create('point');
                action.on('draw-complete', function (evt) {
                    var graphic = _this.createPointGraphic(evt.vertices[0]);
                    _this.addPointGraphic(graphic);
                    _this.createPointDrawAction();
                });
                return [2 /*return*/];
            });
        });
    };
    DrawTextComponent.prototype.createPointGraphic = function (coordinates) {
        var point = {
            type: 'point',
            x: coordinates[0],
            y: coordinates[1],
            spatialReference: this.mapView.spatialReference
        };
        var graphic = new Graphic({
            geometry: point,
            symbol: this.symbolProperties
        });
        return graphic;
    };
    DrawTextComponent.prototype.addPointGraphic = function (graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var title, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.graphicsLayer || this.createLayerForEachGraphic)) return [3 /*break*/, 2];
                        title = graphic.symbol.text;
                        if (title.length > maxTextLayerNameLength) {
                            title = title.slice(0, maxTextLayerNameLength);
                            title = title.slice(0, title.lastIndexOf(' ')) + '...';
                        }
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title, graphicLayer: 'text' })];
                    case 1:
                        _a.graphicsLayer = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.graphicsLayer.add(graphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    DrawTextComponent.prototype.fontFamilyChanged = function () {
        var _this = this;
        var selectedFont = this.fontFamilyOptions.find(function (fontOption) { return fontOption.name === _this.symbolProperties.font.family; });
        if (selectedFont) {
            this.boldDisabled = !selectedFont.bold;
            this.italicDisabled = !selectedFont.italic;
            if (this.boldDisabled && this.symbolProperties.font.weight === 'bold') {
                this.toggleBold();
            }
            if (this.italicDisabled && this.symbolProperties.font.style === 'italic') {
                this.toggleItalic();
            }
        }
        else {
            // Something wrong?
            this.boldDisabled = false;
            this.italicDisabled = false;
        }
    };
    // There are more options for these styles, but for now we're going to match MC1
    // https://developers.arcgis.com/javascript/latest/api-reference/esri-symbols-Font.html
    DrawTextComponent.prototype.toggleBold = function () {
        this.symbolProperties.font.weight = this.symbolProperties.font.weight === 'bold' ? 'normal' : 'bold';
    };
    DrawTextComponent.prototype.toggleItalic = function () {
        this.symbolProperties.font.style = this.symbolProperties.font.style === 'italic' ? 'normal' : 'italic';
    };
    DrawTextComponent.prototype.toggleUnderline = function () {
        this.symbolProperties.font.decoration = this.symbolProperties.font.decoration === 'underline' ? 'normal' : 'underline';
    };
    DrawTextComponent.prototype.setupHandleHiddenLayer = function () {
        var _this = this;
        this.initializing = true;
        var stopInitialCheck = util.debounce(function () { _this.initializing = false; }, initilizeDebounceTime);
        this.listners.push(this.layerService.mapRef.allLayers.on('before-add', function (event) {
            if (_this.initializing && event.item.listMode === 'hide') {
                event.item.set('hideInLegend', true);
                event.item.set('drawTextToolGeneratedLayer', true);
                stopInitialCheck();
            }
        }));
        this.listners.push(this.layerService.mapRef.allLayers.on('after-remove', function (event) {
            if (event.item.get('drawTextToolGeneratedLayer')) {
                _this.initializing = true;
            }
        }));
    };
    DrawTextComponent.prototype.teardownHandleHiddenLayer = function () {
        while (this.listners.length) {
            this.listners.pop().remove();
        }
    };
    return DrawTextComponent;
}(BaseComponent));
export { DrawTextComponent };
